import Joi from "joi";

export interface CreateAssistanceDTO {
    id: number;
    equipmentErpId: string;
    equipmentCarPlate?: string | null;
    equipmentNumSerie: string | null;
    equipmentName?: string | null;
    equipmentBrand: string | null;
    equipmentModel: string | null;

    projectErpId: string | null;
    clientErpId: string | null;
    numDoc: number | null;
    typeDoc: string | null;
    serie: string | null;
    date: Date;
    description: string | null;
    notes: string | null;
    clientId: number | null;
    supportNumber? : string | null;

    counter1: number;
    unit1?: string | null,
    counter2: number;
    unit2?: string | null,
    counter3: number;
    unit3?: string | null,

    assistanceType: string | null;
    stockEntryDocumentErpId: string | null;
    budgetSellingPrice: number | null;
    budgetCostPrice: number | null;

    priority?: number | null;
    workshopInternalNumber?: string | null;
}

export const CreateAssistanceDTOSchema = Joi.object({
    diesel: Joi.number().min(0).messages({ "number.base": "Diesel deve ser um número", "number.min": "Diesel não pode ser inferior a 0" }),
    electric: Joi.number().min(0).messages({ "number.base": "Eletrico deve ser um número", "number.min": "Eletrico não pode ser inferior a 0" }),
    total: Joi.number().min(0).messages({ "number.base": "Total deve ser um número", "number.min": "Total não pode ser inferior a 0" }),
});